import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'external-service-providers' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
